module.exports = __webpack_public_path__ + "static/8a6e5aa0d69dd73c7cd93f33906e928f5bd07974ebf2a6f7553f241dda410e44-55b4fdaa90fc41e8395e513efd527c01.jpeg";